// extracted by mini-css-extract-plugin
export default {"emptyStar":"GuideRatingStars_emptyStar__MeDae"};